import axios from '@/libs/api.request';

export const getCurSaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getCurSaleStat',
        data: data,
        method: 'post'
    });
};

export const getPreSaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getPreSaleStat',
        data: data,
        method: 'post'
    });
};

export const getCombineSaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getCombineSaleStat',
        data: data,
        method: 'post'
    });
};

export const getSalesStatisticalAnalysis = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getSalesStatisticalAnalysis',
        data: data,
        method: 'post'
    });
};

export const getRefundStatisticalAnalysis = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getRefundStatisticalAnalysis',
        data: data,
        method: 'post'
    });
};

export const getCombineSaleStatDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getCombineSaleStatDetail',
        data: data,
        method: 'post'
    });
};

export const getDepositCombineSaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDepositCombineSaleStat',
        data: data,
        method: 'post'
    });
};

export const getDepositCombineSaleStatDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDepositCombineSaleStatDetail',
        data: data,
        method: 'post'
    });
};

export const getSaleTypeRateStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getSaleTypeRateStat',
        data: data,
        method: 'post'
    });
};

export const getMemberCombineSaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getMemberCombineSaleStat',
        data: data,
        method: 'post'
    });
};

export const getMemberCombineSaleStatSql = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getMemberCombineSaleStatSql',
        data: data,
        method: 'post'
    });
};


export const getMemberCombineSaleStatDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getMemberCombineSaleStatDetail',
        data: data,
        method: 'post'
    });
};
export const getMemberCombineSaleStatSqlDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getMemberCombineSaleStatSqlDetail',
        data: data,
        method: 'post'
    });
};
export const getInnerMemberCombineSaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getInnerMemberCombineSaleStat',
        data: data,
        method: 'post'
    });
};

export const getCompanyCombineSaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getCompanyCombineSaleStat',
        data: data,
        method: 'post'
    });
};

export const getDeliverySaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDeliverySaleStat',
        data: data,
        method: 'post'
    });
};

export const getDeliverySaleStatDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDeliverySaleStatDetail',
        data: data,
        method: 'post'
    });
};

export const getMonthlySaleStat = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getMonthlySaleStat',
        data: data,
        method: 'post'
    });
};

export const getDepositStatistics = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDepositStatistics',
        data: data,
        method: 'post'
    });
};

export const getDepositStatisticsDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDepositStatisticsDetail',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmDepositStatList = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getSeedFarmDepositStatList',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmDepositStatSqlList = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getSeedFarmDepositStatSqlList',
        data: data,
        method: 'post'
    });
};
export const getSeedFarmDepositStatDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getSeedFarmDepositStatDetail',
        data: data,
        method: 'post'
    });
};
export const getSeedFarmDepositStatSqlDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getSeedFarmDepositStatSqlDetail',
        data: data,
        method: 'post'
    });
};

export const getSalesStatistical= data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getSalesStatistical',
        data: data,
        method: 'post'
    });
};

// 配送定金统计相关API
export const getDeliveryDepositStatSqlList = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDeliveryDepositStatSqlList',
        data: data,
        method: 'post'
    });
};

export const getDeliveryDepositStatSqlDetail = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getDeliveryDepositStatSqlDetail',
        data: data,
        method: 'post'
    });
};



